module.exports = __webpack_public_path__ + "static/img/3.0528b63.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/loading/img/3.png
// module id = LGrB
// module chunks = 0